export const onClientEntry = () => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.id = 'hs-script-loader';
  script.async = true;
  script.defer = true;
  script.src = '//js-na2.hs-scripts.com/244656772.js';
  document.body.appendChild(script);
};